import { WritebackSettingState } from './writeback.types';

export const INITIAL_WB_SETTINGS_STATE: WritebackSettingState = {
  settingId: '',
  value: false,
  shouldShowSwitch: false,
  shouldDisableSwitch: false,
  failed: false,
  notApplicable: false,
  autoMode: false,
  manualMode: false,
  statusCode: 'Not Applicable',
};

export const FontClassToNameMapping = {
  font1: 'Kaushan Script',
  font2: 'Nothing You Could Do',
  font3: 'Caveat',
  font4: 'Fuzzy Bubbles',
};
